import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({

  routes: [
    {
      path: '/home',
      name: 'home',
      component: () => import('@/page/home'),
    },
    {
      path: '/',
      name: 'layout',
      component: () => import('@/page/layout.vue'),
      redirect: 'home',
      children: [
        {
          path: '/personal', //个人中心
          name: 'personal',
          component: () => import('@/page/personal'),
        },
        {
          path: '/meetingInfo', //会议议程
          name: 'meetingInfo',
          component: () => import('@/page/meetingInfo2'),
        },
        {
          path: '/materialLibrary', //醉美泸州 列表
          name: 'materialLibrary',
          meta: {
            authenticate: true,
          },
          component: () => import('@/page/materialLibrary'),
        },
        {
          path: '/materialDetail', // 素材 下载
          name: 'materialDetail',
          component: () => import('@/page/materialDetail'),
        },
        {
          path: '/login', // 登录
          name: 'login',
          component: () => import('@/page/login'),
        },
        {
          path: '/weather', // 天气
          name: 'weather',
          component: () => import('@/page/weather'),
        },
        {
          path: '/link', // 外链
          name: 'link',
          component: () => import('@/page/link'),
        },
        {
          path: '/news', // 新闻报道 列表
          name: 'news',
          component: () => import('@/page/newsList'),
        },
        {
          path: 'detail', // 新闻报道 详情
          name: 'detail',
          component: () => import('@/page/newsDetail'),
        },
        {
          path: '/singlePage', // 联系我们
          name: 'singlePage',
          component: () => import('@/page/singlePage'),
        }
      ]
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js